import React, { useEffect } from 'react';
import { FetchBannerParams } from 'store/product/types';
import Widgets from 'components/Widgets';

interface Props {
  banners?: any[];
  fetchBanners: (
    params: FetchBannerParams,
    isPaginationEnabled?: boolean
  ) => Promise<void>;
  productId: string;
  isPaginationEnabled?: boolean;
  remainingInventoryIds?: string[];
  queryParamsObject?: object;
  hasUniversalBanners?: boolean;
}

function View({
  banners = [],
  fetchBanners,
  productId,
  isPaginationEnabled,
  remainingInventoryIds,
  queryParamsObject,
  hasUniversalBanners = false,
}: Props) {
  const pageData = hasUniversalBanners ? 'all' : productId;
  useEffect(() => {
    const bannerId = hasUniversalBanners ? 'all' : productId;
    fetchBanners({ productId: bannerId }, isPaginationEnabled);
  }, [fetchBanners, productId, isPaginationEnabled, hasUniversalBanners]);

  return (
    <Widgets
      pageData={pageData}
      widgets={banners}
      remainingInventoryIds={remainingInventoryIds}
      queryParamsObject={queryParamsObject}
    />
  );
}

export default View;
